export const isValidDateInIso = (dateInIso) => {
  if(!dateInIso) return false;
  const testDate = new Date(dateInIso);
  return testDate instanceof Date && !isNaN(testDate);
};
